export const filtersDictionary = {
  Finalidade: 'finalidade',
  Situação: 'situacao',
  'Tipo de Compra': 'tipo-compra',
  'Tipo de Imóvel': 'tipo-imovel',
  'Tipo de Venda': 'tipo-venda',
  'Categoria de Venda': 'categoria-venda',
  Vendedor: 'vendedor',
  noDebts: 'sem-dividas',
  noLegalActions: 'sem-acoes-judiciais',
  visits: 'visitas',
  orderBy: 'ordenacao',
  relevante: 'relevancia',
  'valor-min': 'menorValor',
  'valor-max': 'maiorValor',
  desagio: 'desagio',
  searchId: 'buscaID',
  page: 'pagina',
  discountParam: 'desconto',
  'Modalidade de venda': 'modalidade-venda',
  'modalidade-de-venda': 'modalidade-venda',
  'Formas de pagamento': 'forma-pagamento',
  'Chacara/Sitio': 'Chacara_Sitio',
  'Flat/Hotel': 'flat_hotel',
  'Loja/Salao_Comercial': 'Loja_Salao_Comercial',
}

export const modalsDictionary = {
  exitModal: 'exitModalEmgea',
}

const alertDictionaries = {
  filtersDictionary,
  modalsDictionary,
}

export default alertDictionaries
